import { useEffect } from 'react';

import { useGlobal } from '@/contexts/GlobalContext';
import PageLoading from '@/components/layouts/PageLoading';
import SdHeader from '@/components/layouts/SdHeader';
import SideMenu from '@/components/layouts/SideMenu';
import Header from '@/components/layouts/Header';
import BottomMenu from '@/components/layouts/BottomMenu';
// import ReloadBanner from '@/components/layouts/ReloadBanner';
import TeamSdHeader from '@/components/layouts/teams/SdHeader';
import TeamSideMenu from '@/components/layouts/teams/SideMenu';
import TeamBottomMenu from '@/components/layouts/teams/BottomMenu';
import Tab from '@/components/layouts/Tab';
import { useCurrentTabMenu } from '@/hooks/useCurrentTabMenu';
import { useCurrentTeamTabMenu } from '@/hooks/useCurrentTeamTabMenu';
import { useLoadingControl } from '@/hooks/useLoadingControl';
import UpdatePrompt from '@/components/common/UpdatePrompt';

const AppLayout = ({ children }: { children: React.ReactNode }) => {
  const isLoading = useLoadingControl();
  const context = useGlobal();
  const { menuItems, activeIndex } = useCurrentTabMenu();
  const { menuItems: teamMenuItems, activeIndex: teamActiveIndex } = useCurrentTeamTabMenu();

  // NOTE: バージョンチェックはサービスワーカーの更新監視チェックに移行
  // const [hasNewVersion, setHasNewVersion] = useState<boolean>(false);
  // useEffect(() => {
  //   setHasNewVersion(context.hasAppNewVersion);
  // }, [context.hasAppNewVersion]);

  // NOTE: スクロールバーのレイアウトシフト対応
  useEffect(() => {
    document.documentElement.style.setProperty('scrollbar-gutter', 'stable');
  }, []);

  return (
    <>
      <div className="overscroll-none overscroll-y-none">
        <div className="grid content-start grid-cols-6 sm:grid-cols-6 md:grid-cols-6 lg:grid-cols-12 xl:grid-cols-12 2xl:grid-cols-12 pb-24 lg:pb-0 xl:pb-0 2xl:pb-0 min-h-screen">
          <div className="col-span-6 block sm:block md:block lg:hidden w-full z-20 sticky top-0">
            {context.isTeamPage ? <TeamSdHeader /> : <SdHeader />}
          </div>
          <div className="col-span-3 bg-custom-gradient hidden sm:hidden md:hidden lg:block min-h-screen max-h-screen overflow-y-auto sticky top-0">
            <div className="h-full flex flex-col">
              {!context.isTeamPage && (
                <div>
                  <Header />
                </div>
              )}
              <div className="grow">{context.isTeamPage ? <TeamSideMenu /> : <SideMenu />}</div>
            </div>
          </div>
          {/* メインコンテンツをで9カラム使用し、その9カラムをさらに6カラム(SD)と9カラム(PC)に分ける */}
          <div className="col-span-9 relative grid content-start grid-cols-6 lg:grid-cols-9">
            {/* PCの場合のみ表示（SDはHeader内にTabコンポーネントを追加している） タブの長さは6カラム*/}
            <div className="hidden lg:block col-span-6 lg:px-4 lg:py-0">
              {context.isTeamPage ? (
                <Tab teamColor={context.team?.color_a} menuItems={teamMenuItems} activeIndex={teamActiveIndex} />
              ) : (
                <Tab menuItems={menuItems} activeIndex={activeIndex} />
              )}
            </div>
            <div className="col-span-9 grid grid-cols-6 lg:grid-cols-9">
              {/* このPageLoadingはreact routerのLoaderを使用した際に使われるローディングコンポーネント */}
              {/* 現在、SWRによる初期データ取得に変更したため、ローディングは各Indexで実装しているので注意すること */}
              {isLoading ? <PageLoading /> : <>{children}</>}
            </div>
          </div>
        </div>
      </div>
      <div className="block sm:block md:block lg:hidden w-full z-10 fixed bottom-0">
        {context.isTeamPage ? <TeamBottomMenu /> : <BottomMenu />}
      </div>
      {/* {hasNewVersion && (
        <div className="flex justify-center w-fit z-50 fixed bottom-8 right-0">
          <ReloadBanner />
        </div>
      )} */}
      <div className="flex justify-center w-fit z-50 fixed bottom-8 right-0">
        <UpdatePrompt />
      </div>
    </>
  );
};

export default AppLayout;
